export class TaxFormFile {
    public fileName: string;
    public fileData: string;
  }


// WEBPACK FOOTER //
// ./src/app/models/TaxFormFile.ts